import * as _ from "lodash";
import {Component, NgZone, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Shipment} from "../services/shipment";
import {ShipmentsService} from "../services/shipments.service";
import {MapboxGeoJSONFeature, Marker} from "mapbox-gl";
import {ShipmentRoute} from "../services/shipment-route";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentEvent} from "../services/shipment-event";
import {Lightbox} from "ngx-lightbox";
import {DomSanitizer} from "@angular/platform-browser";
import * as moment from "moment";
import {ShipmentProductLine} from "../services/shipment-product-line";

declare let NProgress: any;

@Component({
    selector: 'app-shipment-event-modal',
    templateUrl: './shipment-event-modal.component.html',
    styleUrls: ['./shipment-event-modal.component.scss'],
    providers: [ShipmentRoutesService]
})

export class ShipmentEventModalComponent implements OnInit {

    modal: NgbModalRef;

    newEvent: ShipmentEvent = null;

    checking = false;
    saving = false;
    saved;
    moved = false;
    shipment: Shipment;
    shipment_product_line: ShipmentProductLine;
    all_states: any[];
    featured_states: any[];
    states: any[];

    constructor(
        public shipmentsService: ShipmentsService,
        public lightbox: Lightbox,
        private sanitized: DomSanitizer
    ) {
    }

    ngOnInit() {

        this.shipmentsService.getShipmentEventStates().then(result => {
            this.all_states = result.results;
            this.featured_states = this.all_states.filter((state) => {
                return state.is_featured;
            });
            this.states = this.all_states.filter((state) => {
                return !state.is_featured;
            });
        })
        this.newEvent = ShipmentEvent.fromJSON({
            foreign_key: this.shipment ? this.shipment.id : this.shipment_product_line.id,
            model: this.shipment ? 'Shipments' : 'ShipmentProductLines',
            date: null,
            status_text: null
        });
    }

    save() {
        this.saving = true;
        this.newEvent.date = moment();
        this.shipmentsService.createShipmentEvent(this.newEvent).then(response => {
            this.shipmentsService.postShipmentChangedEvent(true);
            this.newEvent = null;
            this.modal.close()
        });
    }

    close() {
        this.modal.close();
    }
}
